import React from "react";
import DefaultProductImage from "../../../assets/default-product-image.webp";
import { formatPrice } from "../../../helpers/formatPrice";
export function ProductEntry({ image_url, quantity, price, total, sku, title, description }) {
    return (React.createElement("div", { className: "grid grid-cols-subgrid col-span-12" },
        React.createElement("div", { className: "flex gap-4 col-span-6 border border-t-0 border-r-0 border-neutral-gray px-8 py-2" },
            React.createElement("img", { className: "h-16 w-16 object-contain text-sm", alt: "product-image", src: image_url ?? DefaultProductImage, onError: (e) => {
                    e.currentTarget.src = DefaultProductImage;
                } }),
            React.createElement("div", { className: "w-full flex flex-col gap-2" },
                React.createElement("div", { className: "flex gap-1 font-semibold py-1" },
                    React.createElement("div", null, sku),
                    React.createElement("div", null, title)),
                React.createElement("div", { className: "text-pretty no-wrap text-sm truncate mr-16 py-1" }, description))),
        React.createElement("div", { className: "h-full col-span-2 border border-x-0 border-t-0 border-neutral-gray px-8 py-2 text-gray-700" },
            React.createElement("div", { className: "h-full flex flex-col justify-center" },
                React.createElement("div", { className: "flex justify-start" }, `${formatPrice({
                    value: price?.toString() ?? "0",
                    decimalPlaces: 2,
                })}`))),
        React.createElement("div", { className: "h-full col-span-2 border border-x-0 border-t-0 border-neutral-gray px-8 py-2 text-gray-700" },
            React.createElement("div", { className: "h-full flex flex-col justify-center" },
                React.createElement("div", { className: "flex justify-start" },
                    "x",
                    quantity))),
        React.createElement("div", { className: "h-full col-span-2 border border-l-0 border-t-0 border-neutral-gray px-8 py-2 text-gray-700" },
            React.createElement("div", { className: "h-full flex flex-col justify-center" },
                React.createElement("div", { className: "flex justify-start font-semibold" }, `${formatPrice({
                    value: (parseFloat(price?.toString() ?? "0") * parseInt(quantity?.toString() ?? "0"))?.toString(),
                    decimalPlaces: 2,
                })}`)))));
}
